// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"128":"5669f65e","155":"5538738d","354":"635afdb4","455":"cb82b43c","488":"84bf45e2","685":"8b4a7d21","977":"65c0565d"}[chunkId] + ".chunk.js";
};